/*@ngInject*/
const SendEmailNotificationRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.sendEmailNotification = function (notificationName, isCustom, submissionId, options) {
        let url = '/rest/Email/SendNotification',
            config = {
                params: options ? options.variables : {},
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            },
            payload = 'notificationName=' + notificationName + '&isCustom=' + isCustom + '&submissionId=' + submissionId;
            if (config.params.additionalText) {
              config.params.additionalText = encodeURIComponent(config.params.additionalText);
            }

        return this.post(url, payload, config);
    };
};

angular.module('umCore')
    .service('sendEmailNotificationRepository', SendEmailNotificationRepository);
